//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect';
export default {
	name: 'SelectInput',

	components: { Multiselect },

	props: {
		label: {
			required: false,
			type: String,
		},
		description: {
			required: false,
			type: String,
		},
		value: {
			required: false,
			type: [Object, String, Array, Number],
		},
		placeholder: {
			default: 'Select Option',
			required: false,
			type: String,
		},
		multiple: {
			default: false,
			required: false,
			type: Boolean,
		},
		taggable: {
			default: false,
			required: false,
			type: Boolean,
		},
		empty: {
			default: false,
			required: false,
			type: Boolean,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		searchable: {
			default: false,
			required: false,
			type: Boolean,
		},
		error: {
			default: '',
			required: false,
			type: String,
		},
		options: {
			required: false,
			type: [Array, Object],
		},
		trackBy: {
			default: '',
			required: false,
			type: String,
		},
		text: {
			default: '',
			required: false,
			type: String,
		},
		hideError: {
			default: false,
			required: false,
			type: Boolean,
		},
		direction: {
			default: 'bottom',
			required: false,
			type: String,
		},
	},

	methods: {
		updateValue(value) {
			this.$emit('input', value);
		},
	},
};
